import classNames from 'classnames/bind';
import styles from './Table.module.css';
import TableHead from './TableHead';
import TableBody from './TableBody';

interface Table {
  name?: string;
  headList: any[];
  bodyList: any[];
  keyList: string[];
  selectOptions?: {
    idx: number;
    default: { key: string; value: string };
    values: string[];
    onClick: (value: string, i: number) => void;
  };
  onClickBody: (data: any) => void;
}
export default function Table({
  name = '',
  headList,
  bodyList,
  keyList,
  selectOptions,
  onClickBody,
}: Table) {
  const cx = classNames.bind(styles);

  return (
    <div className={cx(name)}>
      <TableHead list={headList} selectOptions={selectOptions} />
      <TableBody
        name={name}
        list={bodyList}
        keyList={keyList}
        selectOptions={selectOptions}
        onClick={onClickBody}
      />
    </div>
  );
}
